import { render, staticRenderFns } from "./mode4.vue?vue&type=template&id=16a42038&scoped=true"
import script from "./mode4.vue?vue&type=script&lang=js"
export * from "./mode4.vue?vue&type=script&lang=js"
import style0 from "./mode4.vue?vue&type=style&index=0&id=16a42038&prod&lang=scss&scoped=true"
import style1 from "./mode4.vue?vue&type=style&index=1&id=16a42038&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a42038",
  null
  
)

export default component.exports